import React from "react";
import { Box, FormControlLabel, Radio, Typography } from "@mui/material";

interface MyTimeTimePeriodOptionProps {
  value: string | number;
  label: string;
  infoLabel: string;
  isMobile: boolean;
  id: string;
}

export const MyTimeTimePeriodOption: React.FC<MyTimeTimePeriodOptionProps> = ({
  value,
  label,
  infoLabel,
  isMobile,
  id,
}) => {
  return (
    <Box width="100%">
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="flex-start"
        width="100%"
      >
        <Box
          width={isMobile ? "auto" : "200px"}
          textAlign={isMobile ? "left" : "right"}
        >
          <Typography variant="caption" style={{ paddingRight: "16px" }}>
            {label}
          </Typography>
        </Box>
        <Box width={isMobile ? "auto" : "450px"}>
          <FormControlLabel
            value={value}
            control={<Radio id={id} />}
            label={
              !isMobile && (
                <Typography variant="caption">{infoLabel}</Typography>
              )
            }
          />
        </Box>
      </Box>
      {isMobile && (
        <Box style={{ marginLeft: isMobile ? "0px" : "36px" }} textAlign="left">
          <Typography variant="caption">{infoLabel}</Typography>
        </Box>
      )}
    </Box>
  );
};

export default MyTimeTimePeriodOption;
